var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"infinite-bar"},[_vm._v(_vm._s(_vm.formattedDate)+" "),_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"icon-picto-horloge"}),_vm._v(" "),_c('p',[_vm._v("Heure locale")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8380af14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/components/LocalTime.vue
// module id = QZO0
// module chunks = 0